import Box from '@mui/material/Box'
import styled from '@mui/system/styled'

// ฉากหลังทึบแสง เห็นหน้าเดิมลาง ๆ ให้รู้ว่าเป็น popup ไม่ใช่หน้าใหม่
export const StyledQueueOverlay = styled(Box)(({ theme }) => ({
  position: 'fixed',
  inset: 0,
  zIndex: 10000, // สูงกว่า PageLoading (9999)
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflowY: 'hidden',
  padding: theme.spacing(2),
}))

export const StyledQueueCard = styled(Box)(({ theme }) => ({
  width: 640,
  maxWidth: '100%',
  maxHeight: 'calc(100dvh - 32px)', // ไม่ให้ล้นจอ (dvh กัน address bar มือถือ)
  overflowY: 'auto',
  padding: `${theme.spacing(3)} ${theme.spacing(4)}`,
  backgroundColor: theme.palette.background?.paper,
  borderRadius: theme.spacing(1),
  boxShadow: '0px 12px 32px rgba(0, 0, 0, 0.28)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(1.25),
  [theme.breakpoints.down('sm')]: {
    padding: `${theme.spacing(4)} ${theme.spacing(2)}`,
  },
}))
